import { render, staticRenderFns } from "./ScanBody.vue?vue&type=template&id=92c64f7a&"
import script from "./ScanBody.vue?vue&type=script&lang=js&"
export * from "./ScanBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports